import React, { useEffect, useRef, useState } from 'react';
import { Label, Menu } from 'semantic-ui-react';
import { uniqueKey } from '../../common/keys';

const GotoMenu = ({ startHours, handleStartHour }) => {

  const [currentStartHour, setCurrentStartHour] = useState()
  s
  const scrollableDivRef = useRef(null);

  useEffect(() => {
    const menu = document.getElementById('alpha-menu');

    if (!menu) return;

    const htm = (e) => {
      e.preventDefault();
    };

    menu.addEventListener('touchmove', htm, { passive: false });

    return () => {
      menu.removeEventListener('touchmove', htm);
    };
  }, []);

  // useEffect(() => {
  //   const htm = (e) => {
  //     // Check if the touch event target is within the scrollable div 
  //     if (e.target.closest('.menu-alphabet') && e.target.closest('.menu-alphabet').id === 'alpha-menu') {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener('touchmove', htm, { passive: false });

  //   return () => {
  //     document.removeEventListener('touchmove', htm);
  //   };
  // }, [scrollableDivRef]);


  const handleItemClick = (e, { name }) => {
    setCurrentStartHour(name)
    handleStartHour && handleStartHour(name)
    // alpha_handlers.handleSet_alphaItem(name)
  }

  const handleUpdateCurrentStartHour = (e, sh) => {
    if (sh !== currentStartHour) {
      setCurrentStartHour(sh)
      // alpha_handlers.handleSet_currentAlphaIndex(alphaIndex);
      props && props.handleMouseMove && props.handleMouseMove(e, sh)
    }
  }

  const handleTouchMove = (event) => {
    // const touchedItem = document.elementFromPoint(
    //   event.touches[0].clientX,
    //   event.touches[0].clientY
    // );
    // if (touchedItem && touchedItem.attributes && touchedItem.attributes['itemval'] && touchedItem.attributes['itemval'].value) {
    //   const itemValue = parseInt(touchedItem.attributes['itemval'].value) 
    // }
  }

  const handleSetAlphaItem = () => {
    // setCurrentStartHour(currentAlphaIndex)
    // currentHelpers.storageItem_set(storageItem, currentAlphaIndex)
  }

  const handleShowLetter = (e) => {
    if (e) { handleTouchMove(e) }
  }


  const menuItem = (val, isChar, index) => {
    let cn = null
    if (currentStartHour) {
      const _sel = currentStartHour === val
      if (_sel) { cn = 'sel' }
    }
    return <Menu.Item
      className={cn}
      id={'am_' + index}
      itemval={val}
      touchtype={'mi'}
      name={val.toString()}
      key={uniqueKey('abm', val)}
      active={val === currentStartHour}
      onClick={handleItemClick}

    // onMouseMove={(e) => { letterShowing && handleUpdateCurrentStartHour(e, val) }}
    // onMouseUp={(e) => { handleSetAlphaItem(val) }}

    // onTouchStart={(e) => { letterShowing && handleUpdateCurrentStartHour(e, val) }}
    // onTouchMove={(e) => { handleTouchMove(e) }}
    // onTouchEnd={() => { handleSetAlphaItem(val) }}
    >
      {val}
    </Menu.Item>
  }

  const alphaMis = () => {
    const mis = startHours.map((sh, index) => {
      return menuItem(sh, null, index)
    })
    return mis
  }

  let cn = 'menu-alphabet alpha-float abs-side hidden vo-darkest'

  const menu = () => <Menu
    ref={scrollableDivRef}
    id={'sss'}
    onMouseDown={(e) => { handleShowLetter() }}

    onTouchStart={(e) => { handleShowLetter(e) }}
    onTouchMove={(e) => { handleTouchMove(e) }}

    inverted
    borderless
    vertical={true}
    compact={true}
    className={cn}
  >
    {startHours && alphaMis()}
  </Menu >

  return <React.Fragment>
    {menu()}
  </React.Fragment>

}

export default GotoMenu 